module.exports = __webpack_public_path__ + "static/media/7. hdsd app.1853c1c2.svg";